import { AppBar, Toolbar, Box, Button, SvgIcon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ReactComponent as MenuIcon } from "../../assets/icons/hamburger.svg";
import Logo from '../../assets/logo.png'
import OhmMenu from "./OhmMenu.jsx";
import SwitchLang from "./SwitchLang.jsx";
import GCDCSwitch from "./GCDCSwitch.jsx";
import ThemeSwitcher from "./ThemeSwitch.jsx";
import ConnectMenu from "./ConnectMenu.jsx";
import "./topbar.scss";
import "./topbar.app.scss";
import OpenWrap from "./OpenWrap";

const useStyles = makeStyles(theme => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    justifyContent: "flex-end",
    alignItems: "flex-end",
    background: "transparent",
    backdropFilter: "none",
    zIndex: 10,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

function TopBar({ theme, toggleTheme, showPerformance, switchPerformance, handleDrawerToggle }) {
  const classes = useStyles();
  const isVerySmallScreen = useMediaQuery("(max-width: 800px)");

  return (
    <AppBar position="sticky" className={classes.appBar} elevation={0}>
      <Toolbar disableGutters className="dapp-topbar">
        {isVerySmallScreen ? null : <img className="logo" src={Logo} alt="" />}

        <Button
          id="hamburger"
          aria-label="open drawer"
          edge="start"
          size="large"
          variant="contained"
          color="secondary"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <SvgIcon component={MenuIcon} />
        </Button>

        <Box display="flex">
          {/* {!isVerySmallScreen && <OpenWrap theme={theme} />} */}
          <SwitchLang />
          <GCDCSwitch showPerformance={showPerformance} switchPerformance={switchPerformance} />
          <OhmMenu />

          <ConnectMenu theme={theme} />
          {/* <ThemeSwitcher theme={theme} toggleTheme={toggleTheme} /> */}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
